<template>
  <div class="blog-footer-container">

    <section class="footer-child">
      <a href="/pulse" class="s-text-router-link s-flex s-flex-col">
        <h1 class="seedr-title">Seedr.cc</h1>
        <h1 class="blog-title s-text-purple-dark">Blog</h1>
      </a>

      <hr class="s-hr-vertical">

      <div class="links-group social-media-links">
        <a class="s-text-link hover-select" href="https://www.facebook.com/seedrcc/">Facebook</a>
        <a class="s-text-link hover-select" href="https://twitter.com/seedrcoil">X</a>
        <a class="s-text-link hover-select" href="https://www.instagram.com/seedrcc/">Instagram</a>
        <a class="s-text-link hover-select" href="/">LinkedIn</a>
      </div>

<!--      <hr class="s-hr-vertical">-->

<!--      <div class="links-group blog-footer-links">-->
<!--        <a class="s-text-link hover-select" href="/">Link</a>-->
<!--        <a class="s-text-link hover-select" href="/">Link</a>-->
<!--        <a class="s-text-link hover-select" href="/">Link</a>-->
<!--        <a class="s-text-link hover-select" href="/">Link</a>-->
<!--      </div>-->
    </section>

    <section class="footer-copyrights-group s-flex s-flex-center">
      <p class="s-text-small footer-copyrights">&copy; {{ $t('footer.date') }} | {{ $t('footer.rights') }}</p>
    </section>
  </div>
</template>

<script setup>
</script>
